import { useMutation } from "@apollo/client";
import { Block, BlockTitle, Button, Sheet } from "framework7-react";

import { createPage, PageComponentProps } from "@/factories/createPage";
import { FeelingEnum, UpdateEntryFeelingDocument } from "@/generated/graphql/graphql";
import { useSheetPageReady } from "@/hooks/useSheetPageReady";
import feelingBad from "@/images/feeling-bad.png";
import feelingGood from "@/images/feeling-good.png";

export const UpdateFeelingSheetPage = createPage("UpdateFeelingSheetPage", PageComponent);

function PageComponent({ pageName, f7route, f7router }: PageComponentProps) {
  const { getPageProps, swipeHandler } = useSheetPageReady(pageName);

  const [updateEntryFeeling, { loading }] = useMutation(UpdateEntryFeelingDocument, {
    onCompleted: () => {
      f7router.back();
    },
  });

  return (
    <Sheet
      data-component={pageName}
      {...getPageProps()}
    >
      {swipeHandler}
      <BlockTitle
        large
        className="no-margin-top"
      >
        気分はどうですか？
      </BlockTitle>
      <Block
        className="grid grid-cols-2 grid-gap"
        style={{ marginTop: "10vh" }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            large
            preloader
            aria-label="good"
            data-feeling="good"
            loading={loading}
            style={{ borderRadius: "50%", height: "auto", padding: "0.5rem" }}
            onClick={() =>
              updateEntryFeeling({
                variables: {
                  entryFeelingInput: { feelingKey: FeelingEnum.Good },
                  entryId: f7route.params.entryId as string,
                },
              })
            }
          >
            <img
              alt="good"
              src={feelingGood}
            />
          </Button>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            large
            preloader
            aria-label="bad"
            data-feeling="bad"
            loading={loading}
            style={{ borderRadius: "50%", height: "auto", padding: "0.5rem" }}
            onClick={() =>
              updateEntryFeeling({
                variables: {
                  entryFeelingInput: {
                    feelingKey: FeelingEnum.Bad,
                  },
                  entryId: f7route.params.entryId as string,
                },
              })
            }
          >
            <img
              alt="good"
              src={feelingBad}
            />
          </Button>
        </div>
      </Block>
    </Sheet>
  );
}
